module.exports = __webpack_public_path__ + "img/inside_top_float_layer.a990494.png";